import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import coverImage from "../../../../assets/images/misc/course-cover.webp";
import { Button } from "../../../button/Button";
import { CheckIcon } from "../../../graphic/CheckIcon";
import { ShieldLogo } from "../../../graphic/ShieldLogo";
import { TextLogo } from "../../../graphic/TextLogo";
import styles from "./CourseCompleteCard.scss";

const msgKey = "courseCompleteCard";

/**
 * Last card of a course: check mark, a congratulation, the score and what to do next
 */
export const CourseCompleteCard = ({ showing, course, courseResult, onRestartCourse, onCloseCourse }) => {
    const { scoreMax, scoreSum } = courseResult || {};
    const randomTitleNumber = useMemo(() => Math.floor(Math.random() * 5) + 1, []);

    return (
        <div className={styles.base}>
            <div className={styles.background}>
                <img src={course?.cover?.url || coverImage} alt="" />
            </div>

            {showing ? (
                <React.Fragment>
                    <div className={styles.body}>
                        <div className={styles.check}>
                            <CheckIcon />
                        </div>

                        <p className={styles.eyebrow}>
                            <FormattedMessage id={`${msgKey}.eyebrow`} />
                        </p>
                        <h2 className={styles.title}>
                            <FormattedMessage id={`${msgKey}.doneTitle_${randomTitleNumber}`} />
                        </h2>
                        <p className={styles.description}>
                            <FormattedMessage
                                id={`${msgKey}.doneMessage`}
                                values={{ title: course.title, strong: (msg) => <strong>{msg}</strong> }}
                            />
                        </p>

                        {scoreMax > 0 ? (
                            <p className={styles.score}>
                                <FormattedMessage
                                    id={`${msgKey}.scoreCorrect`}
                                    values={{ score: scoreSum, total: scoreMax }}
                                />
                            </p>
                        ) : null}

                        <div className={styles.actions}>
                            <Button fill size="big" color="primary" onClick={onCloseCourse}>
                                <FormattedMessage id={`${msgKey}.continue`} />
                            </Button>
                            <Button fill size="big" icon="repeat" iconColor="primary" onClick={onRestartCourse}>
                                <FormattedMessage id={`${msgKey}.restart`} />
                            </Button>
                        </div>
                    </div>

                    <div className={styles.branding}>
                        <div className={styles.shield}>
                            <ShieldLogo />
                        </div>
                        <div className={styles.wordmark}>
                            <TextLogo color="contrast" size="small" />
                        </div>
                    </div>
                </React.Fragment>
            ) : null}
        </div>
    );
};
